import { useEffect, useState } from "react"
import { debounce } from "underscore"

/**
 * Хук для создания задержки обновления значения
 * @param value актуальное значение
 * @param timeMs время задержки в милиссекундах
 * @return вернет отложенное значение, а после истечения времени вернет актуальное
 * @hook
 * @category Hook
 */
export function useDebouncedValue<T>(value: T, timeMs = 200) {
	const [state, setState] = useState(value)

	useEffect(() => {

		if (state === value) return

		const debounced = debounce(() => {
			setState(value)
		}, timeMs)

		debounced()

		return debounced.cancel
	}, [value, timeMs])

	return state
}